import { animationTransition } from '@shared/utils/animationTransition';
import { Box, StyleSystemProps, styled } from '@withjoy/joykit';

export const StyledSectionRoot = styled(Box)``;
export const StyledGrid = styled(Box)``;
export const StyledGridItem = styled(Box)``;
export const StyledGridItemImageContainer = styled(Box)``;
export const StyledGridItemImage = styled(Box)``;
export const StyledGridItemCtaContainer = styled(Box)``;

export const sectionRootStyles: StyleSystemProps = {
  marginX: 'auto',
  maxWidth: 1680,
  width: '100%',
  paddingX: [null, 6, 7]
};

export const gridStyles: StyleSystemProps = {
  display: 'grid',
  gridTemplateColumns: ['1fr', 'repeat(2, minmax(0, 1fr))', 'repeat(3, minmax(0,1fr))'],
  columnGap: [5, null, null, 8],
  rowGap: [8, null, null, 10],
  marginTop: [6, null, 7]
};

export const gridItemImageContainerStyles: StyleSystemProps = {
  borderRadius: [null, 3],
  overflow: 'hidden',
  display: 'block'
};

export const gridItemImageStyles: StyleSystemProps = {
  display: 'block',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  paddingTop: '100%',
  transition: animationTransition('transform'),
  _groupHover: {
    transform: [null, null, 'scale(1.05) translate3d(0,0,0)']
  }
};

export const gridItemCtaContainerStyles: StyleSystemProps = {
  marginTop: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: 3
};
